import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import auth from './auth';
import list from './list';
import modal from './modal';
import global from './global';
import context from './context';
import contractors from './contractors';
import error from './error';
import confirmModal from './confirm-modal';
import focusedValue from './focused-value';
import alert from './alert';
import tenderEdit from './tender-edit';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'fixtender',
  reducer: (state) => ({
    global: {
      sidebarOpen: state.global.sidebarOpen,
    },
    auth: {
      commentReads: state.auth.commentReads,
      username: state.auth.username,
    },
  }),
});

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    list,
    modal,
    global,
    context,
    error,
    confirmModal,
    focusedValue,
    alert,
    tenderEdit,
    contractors,
  },
  state: {},
  mutations: {},
  actions: {},
  plugins: [vuexLocal.plugin],
});

export const addModule = (moduleName, moduleImport) => {
  if (!store.hasModule(moduleName)) {
    store.registerModule(moduleName, moduleImport);
  }
};

export default store;
